import { PersonInHouseholdDto } from '../graphql/person/generates';

export type SharingPeriodType =
  | 'SEVEN_DAYS'
  | 'THIRTY_DAYS'
  | 'SIX_MONTHS'
  | 'UNLIMITED'
  | 'NICHT_FREIGEBEN';

export enum PeriodEnum {
  SEVEN_DAYS = 'SEVEN_DAYS',
  THIRTY_DAYS = 'THIRTY_DAYS',
  SIX_MONTHS = 'SIX_MONTHS',
  UNLIMITED = 'UNLIMITED',
  NICHT_FREIGEBEN = 'NICHT_FREIGEBEN',
}

export interface ISharingPeriod {
  value: SharingPeriodType;
  label: string;
}

export interface FamilyApprovalType {
  duration: ISharingPeriod;
  householdId?: string;
  customerPersonId?: string;
}

interface PersonApprovalDetails {
  approvalDuration: SharingPeriodType;
  approvedClientId: string;
}

export interface MultipleFamilyApprovalType {
  data: PersonApprovalDetails[] | undefined;
  householdId?: string;
  customerPersonId?: string;
}

export interface MultipleHouseHoldType {
  householdId?: string;
  customerPersonId?: string;
}

export interface PersonMultipleHouseHoldData {
  clientId: string;
  personRegistered: boolean;
  multipleHousehold: boolean;
}

export interface FamilyApprovedPersonDto extends PersonInHouseholdDto {
  familyApprovalStatus?: string;
  familyApprovalDueDate?: string;
  multipleHousehold?: boolean;
  personRegistered?: boolean;
  sharingPeriod?: ISharingPeriod;
}

export interface FamilyApprovalTwoFAMutationType {
  personListOlderEighteen: FamilyApprovedPersonDto[];
  duration: ISharingPeriod;
  customerPersonId?: string;
  keycloakId?: string;
  householdId?: string;
  advisorId?: string;
}

export interface FamilyApprovalTwoFAPersonCentricMutationType {
  personListOlderEighteen: FamilyApprovedPersonDto[];
  customerPersonId?: string;
  keycloakId?: string;
  householdId?: string;
  advisorId?: string;
}
export interface FamilyApprovalTwoFATransactionMutationType {
  transactionId?: string;
  pollingUrl?: string;
  transactionUrl?: string;
}
export interface KundanzuganHaushaltDetailResponse {
  keycloakId: string;
  kundennummer: string;
  vorname: string;
  nachname: string;
  anwendungen: string[];
  registrierungsstatus: string;
  kundenzugang: string[];
  einwilligungVorhanden: boolean;
  haushaltrangfolge: number;
}

export interface FamilyApprovalTwoFAType {
  members: string[];
  duration: string;
  keycloakId?: string;
}

export interface PersonCentricDetail {
  firstName: string;
  lastName: string;
  duration: string;
}

export interface FamilyApprovalTwoFAPersonCentricType {
  confirmation: PersonCentricDetail[];
  keycloakId?: string;
}

export interface KundanzuganHaushaltDetailType {
  householdId?: string;
  advisorId?: string;
}

export interface KundanzuganTransactionStatusType {
  transactionId: string;
}

export interface KundanzuganTransactionStatusResponse {
  status: 'OFFEN' | 'AKZEPTIERT' | 'ABGELEHNT';
}

export interface KundanzuganQRTransactionStatusResponse {
  status: 'OFFEN' | 'AKZEPTIERT' | 'ABGELEHNT' | 'TIMEOUT';
}

export interface KundanzuganTransactionResponse {
  transactionId: string;
  transactionUrl: string;
  pollingUrl: string;
  status?: 'OFFEN' | 'ABGELEHNT' | 'TIMEOUT';
}
